import React from "react";
import img from "../../../../../assets/images/journal/j-indicator-sample.jpg";

const RCategoryRank = (parent) => {
    const record = parent.record;
    return (
        <div className="mt-6">
            <div className="justify-content-between align-items-center mb-px-10">
                <div className="align-items-center">
                    <h3 className="con-title mb-px-10">카테고리별 랭킹 정보</h3>
                </div>
                <div className="dot-text">
                    <div className="text font-size-14 ml-px-17">※ 카테고리별 [상위 %] 산출식 : (해당 저널 카테고리별 순위/해당 저널 카테고리별 총 저널
                        수)X100
                    </div>
                    <div className="text font-size-14 ml-px-17">- 카테고리별 순위, 저널 수 기준 : JCR(Rank by Journal Impact
                        Factor),
                        Scopus(CiteScore rank), KCI(학술지인용정보의 KCI IF (2년))
                    </div>
                    <div className="text font-size-14 ml-px-17"><span style={{color: 'red'}}>* 저널 수, 저널 랭킹, 상위%의 괄호 안에 있는 값은 ESCI 저널을
					제외한 SCIE, SSCI, AHCI 저널의 랭킹을 계산한 수치입니다.</span>
                    </div>
                </div>
            </div>
            {record.error_code === 'login' ?
                <img src={img} style={{width: "100%"}}/>
                :
                <div>
                    <table className="table table-lightgray">
                        <colgroup>
                            <col width="8%"/>
                            <col width="9%"/>
                            <col width="34%"/>
                            <col width="8%"/>
                            <col width="9%"/>
                            <col width="8%"/>
                            <col width="8%"/>
                          <col width="8%"/>
                          <col width="8%"/>
                      </colgroup>
                      <thead>
                      <tr>
                          <th scope="col" className="">No.</th>
                          <th scope="col" className="">구분</th>
                          <th scope="col" className="text-left">카테고리명</th>
                          <th scope="col" className="">저널 수</th>
                          <th scope="col" className="">저널 랭킹</th>
                          <th scope="col" className="">상위%</th>
                          <th scope="col" className="">Percentile</th>
                          <th scope="col" className="">Quartile</th>
                          <th scope="col" className="">연도</th>
                      </tr>
                      </thead>
                      <tbody>
                      {record.category_ranking && record.category_ranking.map((item, num) => {
                          return (
                              <tr key={num}>
                                  <td className="">{num + 1}</td>
                                  <td className="">{item.indicator_type ? item.indicator_type.toUpperCase() : ''}</td>
                                  <td
                                      className="text-left">{item.edition ? item.edition.toUpperCase() + ' - ' : ''}{item.category_name}</td>
                                  <td className="">{item.category_count ? item.category_count : 'N/A'}
                                      {item.indicator_type === 'jcr' && item.category_count2 != null && item.indicator_year >= 2023 &&
                                          <>
                                              <br/>
                                              {'(' + item.category_count2 + ')'}<sup>*</sup>
                                          </>
                                      }</td>
                                  <td className="">{item.ranking ? item.ranking : 'N/A'}
                                      {item.indicator_type === 'jcr' && item.ranking2 != null && item.indicator_year >= 2023 &&
                                          <>
                                              <br/>
                                              {'(' + item.ranking2 + ')'}<sup>*</sup>
                                          </>
                                      }</td>
                                  <td className="">{item.percent ? item.percent + '%' : 'N/A'}
                                      {item.indicator_type === 'jcr' && item.percent2 != null && item.indicator_year >= 2023 &&
                                          <>
                                              <br/>
                                              {'(' + item.percent2 + '%)'}<sup>*</sup>
                                          </>
                                      }</td>
                                  <td className="">{item.percentile ? item.percentile : 'N/A'}</td>
                                  <td className="">{item.quartile ? item.quartile : 'N/A'}</td>
                                  <td className="">{item.indicator_year}</td>
                              </tr>
                          )
                      })}
                      </tbody>
                  </table>
              </div>
            }
        </div>
    );
};

export default RCategoryRank;
